let language = {
    // store-status
    STORE_ORDERS_ALL_STORE: "所有的",
    STORE_ORDERS_STORE_LABEL_NAME: "商店:",

    // btn-send-to
    STORE_ORDERS_BTN_SEND_TO: "发送到",
    
    // store-orders-search/filter/sort
    STORE_ORDERS_FILTER_ORDER_DATE: "订单时间:",
    STORE_ORDERS_SEARCH_INPUT_PLACEHOLDER: "搜索顺序",

    // header
    STORE_ORDERS_HEADER_ORDER_NUMBER: "订单号",
    STORE_ORDERS_HEADER_DATE: "日期",
    STORE_ORDERS_HEADER_ORDER_STATUS: "订单状态",
    STORE_ORDERS_HEADER_SUBMITTED_TO: "提交到",
    STORE_ORDERS_HEADER_RETAIL_TOTAL: "零售总额",

    // content
    STORE_ORDERS_CONTENT_SUBMITTED_STATUS_PAID: "支付:",
    STORE_ORDERS_CONTENT_SUBMITTED_STATUS_UNPAID: "未支付:",
    STORE_ORDERS_CONTENT_IS_ORDERED: "提交",
};

export { language }